import { render, staticRenderFns } from "./CommonUserSearchAutocomplete.vue?vue&type=template&id=7c980c64"
import script from "./CommonUserSearchAutocomplete.vue?vue&type=script&lang=js"
export * from "./CommonUserSearchAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports